import React from "react";
import { HStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import useThemeToken from "@UI/hooks/useThemeToken";
import { Icon } from "@UI/Components/Icon/Icon";
import { WhiteSuperTalentBadge } from "@UI/Components/Icons/WhiteSuperTalent";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";
import { InfoCircle } from "@UI/Components/Icons/Info";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
} from "@UI/Components/Popover/Popover";
import { Portal } from "@UI/Components/Portal/Portal";

export const SuperTalentPillBadge = (props: {
  popoverContent: React.ReactNode;
}) => {
  const { popoverContent } = props;

  const pink500 = useThemeToken("colors", "pink.500");
  const orange500 = useThemeToken("colors", "orange.500");
  const pink600 = useThemeToken("colors", "pink.600");
  const orange600 = useThemeToken("colors", "orange.600");

  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <HStack
          spacing="4px"
          px="8px"
          py="4px"
          borderRadius="18.19px"
          background={`linear-gradient(96.51deg, ${pink500} 0%, ${orange500} 99.87%);`}
          _hover={{
            background: `linear-gradient(96.51deg, ${pink600} 0%, ${orange600} 99.87%);`,
          }}
          w="fit-content"
          h="fit-content"
          cursor="pointer"
          lineHeight="12px"
        >
          <Icon as={WhiteSuperTalentBadge} w={{ base: "10px", lg: "12px" }} />
          <Text
            color="white"
            fontWeight={700}
            fontSize={{ base: "xs", lg: "sm" }}
          >
            <FormattedMessage {...messages.superTalentName} />
          </Text>
          <Icon
            as={InfoCircle}
            w={{ base: "10px", lg: "12px" }}
            display="inline"
            color="white"
          />
        </HStack>
      </PopoverTrigger>
      <Portal selector="body">
        <PopoverContent maxW="190px" bg="gray.800">
          <PopoverArrow bg="gray.800" />
          <PopoverBody>{popoverContent}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
